const getBlogSectionsString = ({ blogCategories }: SiteConfig) => {
  const categories = blogCategories.map((category) => `blog-${category}`);
  return categories.join(',');
};

export default getBlogSectionsString;
